module.exports = "https://health.dajiuxing.com.cn/img/views/login/img/Selected.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Flogin%2Fimg%2FSelected.png
// module id = cQgV
// module chunks = 93